import React from 'react';
import { IconButton, withStyles, StyledComponentProps } from '@material-ui/core';
import { styles } from './styles';
import clsx from 'clsx';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
require('moment/locale/it.js');


interface IProps extends StyledComponentProps {
    label?: string;
    value: Date;
    onChange?: (val: Date) => any;
    placeholder?: string;
    fullWidth?: boolean;
    disabled?: boolean;
    key: string;
}

// const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
//     event.preventDefault();
// };

const handleWeekChange = (date: moment.Moment, props: IProps) => {
    props.onChange(moment(date).startOf("week").toDate())
};

const formatWeekSelectLabel = (date, invalidLabel) => {
    let dateClone = moment(date);
    const start = moment(dateClone).startOf("week");
    const end = moment(dateClone).endOf("week");
    return dateClone && dateClone.isValid
        ? `dal ${moment(start).format("DD/MM/YYYY")} al ${moment(end).format("DD/MM/YYYY")}`
        : "error";
};

const renderWrappedWeekDay = (date: moment.Moment, selectedDate: moment.Moment, dayInCurrentMonth: boolean, props: IProps) => {
    const { classes } = props;
    let dateClone = moment(date);
    let selectedDateClone = moment(selectedDate);

    const start = moment(selectedDateClone).startOf("week").subtract(1, 'd');
    const end = moment(selectedDateClone).endOf("week");

    const dayIsBetween = dateClone.isBetween(start, end);
    const isFirstDay = dateClone.isSame(start, 'day');
    const isLastDay = dateClone.isSame(end, 'day');

    const wrapperClassName = clsx({
        [classes.highlight]: dayIsBetween,
        [classes.firstHighlight]: isFirstDay,
        [classes.endHighlight]: isLastDay,
    });

    const dayClassName = clsx(classes.day, {
        [classes.nonCurrentMonthDay]: !dayInCurrentMonth,
        [classes.highlightNonCurrentMonthDay]: !dayInCurrentMonth && dayIsBetween,
    });

    return (
        <div className={wrapperClassName}>
            <IconButton className={dayClassName}>
                <span> {dateClone.format("D")} </span>
            </IconButton>
        </div>
    );
};

const WeekPicker = (props: IProps) => {
    // const { classes, ...otherProps } = props;
    // const { classes } = props;
    // const { text, label, clearIcon } = classes;

    return (
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale='it'>
            <DatePicker
                key={props.key}
                label={props.label}
                value={props.value}
                disabled={props.disabled}
                placeholder={props.placeholder}
                fullWidth={props.fullWidth}
                autoOk
                disableToolbar
                color="secondary"
                id="week-picker"
                onChange={(date) => handleWeekChange(date, props)}
                renderDay={(day: moment.Moment, selectedDate: moment.Moment, dayInCurrentMonth: boolean, dayComponent: JSX.Element) => renderWrappedWeekDay(day, selectedDate, dayInCurrentMonth, props)}
                labelFunc={(date, invalidLabel) => formatWeekSelectLabel(date, invalidLabel)}
            />
        </MuiPickersUtilsProvider>
    );
}

export default withStyles(styles as any)(WeekPicker);